<div class="p-1">
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    @if (disabledMessage) {
    <p-dialog [draggable]="false" [visible]="isDialogVisible" [closable]="false" appendTo="self">
      <i class="pi pi-exclamation-circle pr-1"></i> <label>{{ disabledMessage }}</label> <br />
      <br />
    </p-dialog>
    }

    <form [formGroup]="annulusContentsForm" novalidate>

      <div class="flex flex-col">
        <div>
          <label class="pt-1 pb-1">
            Hanger Pressure
          </label>
          <i pTooltip="Default pressure assumed for thermal simulations after landing & setting the string" class="pi pi-info-circle cursor-help relative z-[2]"></i>
        </div>
          @if (!isOutermostString) {
            <app-validated-number-input
              (focusout)="hangerPressureChange()"
              [id]="'hangerPressure'"
              [control]="hangerPressureControl"
              [value]="hangerPressureControl.value"
              [validation]="pressureValidation"
              [unit]="pressureUnit"
            ></app-validated-number-input>
          } @else {
            <p-input-group>
              <p-inputNumber
                [minFractionDigits]="1"
                [placeholder]="seawaterHydrostaticAtHanger"
                [disabled]="true"
              ></p-inputNumber>
              <p-inputgroup-addon>{{ pressureUnit }}</p-inputgroup-addon>
            </p-input-group>
          }
      </div>

      <p class="text-sm mb-2 mt-5"> Multiple annular fluid layers may be selected for the post-completion state of
        the wellbore:
      </p>

      <div class="grid">
          <p-contextMenu #cm [model]="contextMenuItems" appendTo="body"></p-contextMenu>
          <ng-container formArrayName="annulusContents">
            <p-table [ariaDisabled]="stringFullyCemented" [scrollable]="true" [scrollHeight]="tableHeight"
              [appAutoTableHeight]="true"
              [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
              [appAutoTableHeightOffset]="170"
              (appAutoTableHeightChange)="tableHeight = $event"
              styleClass="p-datatable-gridlines" [columns]="columnDefs" [resizableColumns]="true"
              [value]="annulusContents?.controls" [(contextMenuSelection)]="selectedRowIdx" 
              dataKey="value.id"
              [contextMenu]="cm">
              <ng-template pTemplate="header" let-columns let-wIdx="rowIndex">
                <tr (mouseover)="getRowIndex(wIdx)">
                  @for (col of columns; track col.header) {
                  <th pResizableColumn> {{ col.header }} </th>
                  }
                  <th class="place-items-center">
                    <p-button
                      class="outlined-button"
                      severity="success"
                      size="small"
                      [disabled]="annulusContents?.invalid || stringFullyCemented" 
                      label="Add"
                      outlined="true"
                      (click)="onAddAnnulusContent()">
                    </p-button>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-annulusSectionFg let-rIdx="rowIndex">
                <ng-container [formGroupName]="rIdx">
                  <tr>
                    <td [pContextMenuRow]="rIdx" class="text-center" style="width: 15%;">
                        <p-inputNumber formControlName="annulusSectionBottom" [minFractionDigits]="1"
                          [title]="!isControlInvalid(annulusSectionFg, 'annulusSectionBottom') 
                            ? 'Section Bottom' 
                            : getControlErrors(annulusSectionFg, 'annulusSectionBottom') + ' ' + depthUnit"
                        ></p-inputNumber>
                    </td>
                    <td [pContextMenuRow]="rIdx" style="width: 40%;" class="text-center">
                      <p-select filter filterBy="label" resetFilterOnHide="true" class="w-full" [disabled]="userRoles.readOnly" placeholder="Select" [options]="fluids"
                        formControlName="annulusSectionContent" appendTo="body">
                      </p-select>
                    </td>
                    <td [pContextMenuRow]="rIdx" class="text-center" style="width: 15%;">
                      <p-checkbox size="small" title="Include Natural Convection" 
                        binary="true" formControlName="naturalConvection"/>
                    </td>
                    <td [pContextMenuRow]="rIdx" class="text-center" style="width: 15%;" >
                      <p-checkbox size="small" title="Include Radiation" binary="true"
                        formControlName="radiation"/>
                    </td>
                    <td [pContextMenuRow]="rIdx" class="text-center" style="width: 95px">
                      <p-button size="small" severity="danger" text
                        title="Remove Annulus Section" icon="pi pi-trash"
                        [disabled]="rIdx == annulusContents.length - 1" 
                        (click)="onDeleteSection(rIdx)">
                      </p-button>
                    </td>
                  </tr>
                </ng-container>
              </ng-template>
            </p-table>
          </ng-container>
        </div>
    </form>

    @if (tubularCemented) {
    <p class="text-sm pt-2">Hard Cement is applied below TOC {{ tocLabel }} </p>
    }

  </app-tool-loader>
</div>